/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { SdsDivProps } from '../Component.props';
import { LINK_TARGET_SELF, LinkTarget } from './types/LinkTarget.types';
import { LINK_TYPE_STANDALONE, LinkType } from './types/LinkType.types';

/**
 * The props for `<Link />`.
 */
export interface LinkProps extends SdsDivProps {
  /**
   * Link button type click event handler.
   */
  customClick?(event: React.MouseEvent): void;

  /**
   * Determine whether to hide the link icon.
   */
  hideIcon?: boolean;

  /**
   * The link href. Not needed for button links.
   */
  href?: string;

  /**
   * The link icon.
   */
  icon?: JSX.Element;

  /**
   * The link target.
   */
  target?: LinkTarget;

  /**
   * The link text.
   */
  text: string;

  /**
   * The link type.
   */
  type?: LinkType;
}

/**
 * The default prop values for `<Link />`.
 */
export const linkDefaults = {
  hideIcon: false,
  href: `#`,
  target: LINK_TARGET_SELF,
  type: LINK_TYPE_STANDALONE,
};
